import { type ComponentPropsWithoutRef } from 'react';
import { css, styled } from 'styled-components';

const Highlight = styled.div`
  ${({ theme }) => css`
    & > :first-child {
      background: ${theme.colorsV2.yellow05};
      border-radius: 10px;
      padding: 12px;

      ${theme.mediaQueries.lg} {
        width: calc(100% + 24px);
        margin-top: -12px;
        margin-left: -12px;
        margin-right: -12px;
      }
    }
  `}
`;

export const Highlighter = ({
  addContainer = false,
  children,
  isHighlighted = false,
  ...props
}: ComponentPropsWithoutRef<'div'> & {
  readonly addContainer?: boolean;
  readonly isHighlighted?: boolean;
}) => {
  return isHighlighted ? (
    <Highlight
      data-highlight="true"
      {...props}
    >
      {addContainer ? <div>{children}</div> : <>{children}</>}
    </Highlight>
  ) : (
    <>{children}</>
  );
};
